import { Box, CircularProgress, Typography, Divider } from "@mui/joy";
import { useFormContext } from "react-hook-form";
import { SaveRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import { Button } from "../../../../../shared";

interface ActionProps {
    api: any;
}

export default function Action({ api }: ActionProps) {
    const navigate = useNavigate();
    const {
        formState: { isValid: isFormValid, isDirty: isFormDirty },
    } = useFormContext();

    return (
        <Box mt={2}>
            <Divider sx={{ mb: 1 }} />
            <Typography level={"body-sm"} sx={{ mb: 1 }}>
                Below action will create a new supplier in the system.
            </Typography>
            <Box display={"flex"} gap={2}>
                <Button variant={"outlined"} color={"neutral"} onClick={() => navigate("/suppliers/list")}>
                    Cancel
                </Button>
                <Button
                    disabled={api.isPending || !(isFormValid && isFormDirty)}
                    type={"submit"}
                    loading={api.isPending}
                    startDecorator={<SaveRounded />}
                    loadingPosition={"start"}
                    variant={"soft"}
                    color={"primary"}
                >
                    Create Supplier
                </Button>
            </Box>
        </Box>
    );
}
